export default __webpack_public_path__ + "static/media/1776.720d34d2.png";